import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-width: 400px;
  max-width: 500px;
`;

export const Content = styled.div`
  padding: 1.5rem;
  flex: 1;
  overflow-y: auto;
`;

export const Loading = styled.div`
  text-align: center;
  padding: 2rem 0;
  color: ${(props) => props.theme.colors?.text?.secondary};
`;

export const AddButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.75rem;
  margin-bottom: 1rem;
  background-color: ${(props) => props.theme.colors?.primary};
  color: ${(props) => props.theme.colors?.white01};
  border: none;
  border-radius: 0.5rem};
  cursor: pointer;
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs12};
  font-weight: 500;
  transition: background-color 0.2s;

  &:hover {
    opacity: 0.9;
  }
`;

export const ParticipantsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 2rem 0;
  color: ${(props) => props.theme.colors?.text?.secondary};
`;

export const EmptyText = styled.p`
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs12};
`;

export const ParticipantItem = styled.div`
  display: flex;
  align-items: center;
  padding: 0.75rem;
  border-radius: 0.5rem;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${(props) => props.theme.colors?.gray01};
  }
`;

export const AvatarContainer = styled.div`
  position: relative;
  margin-right: 0.75rem;
`;

export const Avatar = styled.img`
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  object-fit: cover;
`;

export const AvatarPlaceholder = styled.div`
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  background-color: ${(props) => props.theme.colors?.primary};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.theme.colors?.white01};
  font-weight: 600;
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs16};
`;

export const ParticipantInfo = styled.div`
  flex: 1;
`;

export const ParticipantName = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 500;
  color: ${(props) => props.theme.colors?.text?.primary};
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs12};
`;

export const AdminBadge = styled.span`
  padding: 0.125rem 0.5rem;
  background-color: ${(props) => props.theme.colors?.primary};
  color: ${(props) => props.theme.colors?.white01};
  border-radius: 0.25rem;
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs12};
  font-weight: 600;
`;

export const RemoveButton = styled.button`
  padding: 0.5rem;
  background: none;
  border: none;
  color: ${(props) => props.theme.colors?.danger};
  cursor: pointer;
  border-radius: 0.5rem;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: ${(props) => (props.theme.colors?.danger) + '20'};
  }
`;

